import {
    addDays,
    startOfWeek,
    endOfWeek,
    addWeeks,
    startOfMonth,
    endOfMonth,
    addMonths,
    startOfYear,
    endOfYear,
    addYears,
    startOfDay,
    endOfDay,
    differenceInHours,
    differenceInDays,
    differenceInMonths,
    isSameDay,
} from "date-fns";
import type {Locale} from "date-fns";
import type {DateRange} from "./types/utils";


function move(amount: number, start: Date, end: Date, locale?: Locale): DateRange {
    
    const hours = differenceInHours(end, start)
    if (hours < 25) {
        // day
        return {
            startDate: startOfDay(addDays(start, amount)),
            endDate: endOfDay(addDays(end, amount)),
        }
    }

    const days = differenceInDays(end, start)
    if (days == 6 && isSameDay(startOfWeek(start, {locale}), start) && isSameDay(endOfWeek(start, {locale}), end)) {
        // week
        return {
            startDate: startOfWeek(addWeeks(start, amount), {locale}),
            endDate: endOfWeek(addWeeks(start, amount), {locale}),
        }
    }

    const months = differenceInMonths(end, start)
    if (months == 0 && days > 26 && isSameDay(startOfMonth(start), start) && isSameDay(endOfMonth(start), end)) {
        // month
        return {
            startDate: startOfMonth(addMonths(start, amount)),
            endDate: endOfMonth(addMonths(start, amount)),
        }
    }

    if (months == 11 && isSameDay(startOfYear(start), start) && isSameDay(endOfYear(start), end)) {
        // year
        return {
            startDate: startOfYear(addYears(start, amount)),
            endDate: endOfYear(addYears(start, amount)),
        }
    } else {
        // day
        return {
            startDate: startOfDay(addDays(start, amount * (days + 1))),
            endDate: endOfDay(addDays(end, amount * (days + 1))),
        }
    }
}

export function minus(start: Date, end: Date, locale?: Locale): DateRange {
    return move(-1, start, end, locale)
}

export function plus(start: Date, end: Date, locale?: Locale): DateRange {
    return move(1, start, end, locale)
}
